'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'volleyball';
var width = 512;
var height = 512;
var aliases = [127952,"volleyball-ball"];
var unicode = 'f45f';
var svgPathData = 'M415.1 413.7c-85.3 20-177.8 6.8-256.2-42.8-13.5 21.4-24.2 44.4-31.9 68.2 36.5 25.8 81 40.9 129.1 40.9 62.2 0 118.5-25.4 159.1-66.3zm34-44c10.9-18.4 19.2-38.5 24.4-59.8-72 12.5-148.4 1.8-217.2-35.5-31 19.1-57.5 43.1-78.9 70.2 83.6 52.2 184.6 59.1 271.7 25zm30.1-93.4c.6-6.7 .9-13.4 .9-20.3 0-99.3-64.6-183.5-154.1-212.9 52.5 65.3 80.6 150 72.9 239.3 27.1 1.5 54.1-.6 80.3-6.2zM272.8 32.6c-5.5-.4-11.1-.6-16.8-.6-21.5 0-42.3 3-62 8.7 46.8 56.1 75.7 127.6 77.9 205.8 30.5 16.4 62.6 27.1 95.1 32.4 8-95.3-29.1-184.8-94.2-246.4zM162 52.6c-76.7 35.5-130 113.2-130 203.4 0 7.5 .4 14.9 1.1 22.1 34.4-69.3 92.8-127.1 169.6-159.7l3.7-1.6c-12-23.3-27-44.9-44.4-64.2zM45.3 332.3c11.8 32.5 30.9 61.5 55.3 85 25.1-68.6 72.6-129.3 139.3-170.3-1-35.5-8.2-69.5-20.4-100.9l-4.4 1.9C131.4 183.5 71.8 252.2 45.3 332.3zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faVolleyball = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;